import React from 'react';
import i18n from 'i18next'; import { Map } from 'immutable';
import CheckBox from 'components/checkbox/CheckBox';
import PropTypes from 'prop-types';

const StartMotivatorAssessment = ({
    user,
    employees,
    candidate,
    onStartAssessment,
    isLoading,
    termsAndPolicyIsChecked,
    handleClick,
    hideTermsAndConditions = false
}) => {
    return (
        <div className='sw-btn-start'>
            {!hideTermsAndConditions && (user.get('userRoleId') !== 1) && <div className='term-policy'>
                <CheckBox
                    text={ i18n.t('welcome.i_accept_attuned') }
                    languageId={ user.get('languageId') }
                    onChange={ handleClick }
                    checked={ termsAndPolicyIsChecked }
                    disable={ isLoading } />
                { user.get('respondentRoleId') === 3 && employees }
                { user.get('respondentRoleId') === 4 && candidate }
            </div>}
            <button
                className='fl-survey-wc-btn'
                disabled={ (!termsAndPolicyIsChecked || isLoading) && user.get('respondentRoleId') !== 1 && user.get('respondentRoleId') !== 2 && user.get('respondentRoleId') !== 5 }
                onClick={ () => !isLoading && onStartAssessment(user) }>
                { isLoading ? <span>
                    <i className='fa fa-spinner fa-spin fa-fw' /> { i18n.t('welcome.start_assessment') }
                </span> : i18n.t('welcome.start_assessment') }
            </button>
        </div>
    );
};

StartMotivatorAssessment.propTypes = {
    user: PropTypes.object,
    employees: PropTypes.object,
    candidate: PropTypes.object,
    onStartAssessment: PropTypes.func,
    isLoading: PropTypes.bool,
    termsAndPolicyIsChecked: PropTypes.bool,
    handleClick: PropTypes.func,
    hideTermsAndConditions: PropTypes.bool
};

StartMotivatorAssessment.defaultProps = {
    termsAndPolicyIsChecked: false,
    hideTermsAndConditions: false,
    user: new Map(),
    employees: () => ({}),
    candidate: () => ({}),
    isLoading: false,
    handleClick: () => ({}),
    onStartAssessment: () => ({})
};

export default StartMotivatorAssessment;
